import {Navigate, Outlet} from "react-router-dom";
import {useRecoilValue} from "recoil";
import {authenticationStatusSelector} from "../states/user/userSelectors";
import {authLoadingState} from "../states/user/userAtom";

/**
 * 로그인되지 않은 상태에서만 접근 가능한 루트
 * 로그인된 유저가 이 루트에 접근하는 경우 default로 리다이렉트된다
 */
export function NotLoginRoute() {
    const isAuthLoading = useRecoilValue(authLoadingState);
    const isAuthenticated = useRecoilValue(authenticationStatusSelector);
    if (isAuthLoading) {
        return <div>Loading...</div>
    }

    console.log(`isAuthenticated: ${isAuthenticated}`)

    return isAuthenticated ? <Navigate to={"/default"} /> : <Outlet />
}
